import React from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

export const renderStatusArrow = (status) => {
    if (status === 1 || status === '1') {
        return <ArrowBackIcon fontSize="small" />;
    }
    if (status === 3 || status === '3') {
        return <ArrowForwardIcon fontSize="small" />;
    }
    return <HorizontalRuleIcon fontSize="small" />;
};
